import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import CategoryModal from "../../components/modal/CategoryModal";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { langState, langText } from "../../recoil/lang";
import { useRecoilValue, useRecoilState } from "recoil";
import {
  CouponType,
  OrderCouponType,
  OrderDataType,
  OrderInfoType,
  paymentRealmType,
} from "../../recoil/type";
import ApiController from "../../controller/ApiController";
import moment from "../../utils/moment";
import {
  getProductName,
  getPrdName,
  getOptionTypeName,
  getOptionName,
  contentName,
} from "../../utils/util";

const OrderDetails = () => {
  const location = useLocation();
  const orderData: OrderDataType = location.state;
  const [lang, setLang] = useRecoilState<number>(langState);
  const [orderDetailData, setOrderDetailData] = useState<OrderInfoType>();
  const navigate = useNavigate();

  // 쿠폰
  const [couponList, setCouponList] = useState<OrderCouponType[]>([]);

  React.useEffect(() => {
    ApiController.order.getOrderByOrderId(orderData.order_id).then((res) => {
      if (res.ok) {
        console.log("getOrder", res.data);
        setOrderDetailData(res.data);
        setCouponList(res.data.order.child[0].coupons);
      }
    });
  }, []);

  const RenderHeader = () => {
    return (
      <div className="modalHeader">
        <h3>{langText.orderStatus_button_history[lang]}</h3>
        {/* <div className="row gap">
          <div className="badge">
            <h3>{langText.paymentListModal_title_pickup_location[lang]}</h3>
            <h3>⮕</h3>
            <h3 className="pickupName">
              {lang === 0 ? orderInfo.pickup_name : orderInfo.pickup_name_en}
            </h3>
          </div>
        </div> */}
        <img
          className="backIcon"
          onClick={() => {
            navigate(-1);
          }}
          src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_left.svg`}
          alt="back"
        />
      </div>
    );
  };

  const RenderPaymentList = () => {
    return (
      <div className={`paymentListWrap`}>
        {orderDetailData?.order.child.map((child, index: number) => (
          <>
            {child.detail.map((detail, index) => (
              <div key={index} className="menuContent">
                <div className="orderIndex">
                  <p>{index + 1}</p>
                </div>
                <div className="orderTitle">
                  <div className="menuTitleWrap">
                    <div className="menuNameWrap">
                      <div
                        className={
                          detail.product_discount_amount > 0
                            ? "menuNameShot"
                            : "menuName"
                        }
                      >
                        <h3>{getProductName(detail, lang)}</h3>
                      </div>
                      {detail.product_discount_amount > 0 && (
                        <div className="badge">
                          <h3>
                            {detail.product_discount_amount}원{" "}
                            {langText.discount[lang]}
                          </h3>
                        </div>
                      )}
                    </div>
                    {detail.options.map((option, optionIndex: number) => (
                      <div key={optionIndex} className="orderOption">
                        <img
                          src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_lineBreak.svg`}
                          alt="옵션아이콘"
                        />
                        <div className="optionCategory">
                          <span>&#91;</span>
                          <p className="optionCategoryName">
                            {getOptionTypeName(option, lang)}
                          </p>
                          <span>&#93;</span>
                        </div>
                        <p className="optionName">
                          {getOptionName(option, lang)}
                        </p>
                        {/* <p className="optionPrice">
                    {option.option_price.toLocaleString()}원
                  </p> */}
                      </div>
                    ))}
                    {detail.set_prd_type_list.map(
                      (set_product, prd_group_index) => (
                        <div className="optionLine">
                          <img
                            src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_lineBreak.svg`}
                            alt="옵션아이콘"
                          />

                          {set_product.set_prd_type_min > 0 ? (
                            <p className="optionCategoryName">
                              [{langText.setOptionModal_configuration[lang]}
                              {prd_group_index + 1}]
                            </p>
                          ) : (
                            <p className="optionCategoryName">
                              [{langText.setOptionModal_addtional[lang]}]
                            </p>
                          )}
                          <div className="optionCategory">
                            {set_product.set_product.map(
                              (pickProduct, prd_index) => (
                                <div className="setOrderOption" key={prd_index}>
                                  <p> {getProductName(pickProduct, lang)}</p>
                                  {pickProduct.options.length > 0 && (
                                    <div className="optionBreak">
                                      <div className="optionBreakLine"></div>
                                      <h5>
                                        ({langText.setOptionModal_option[lang]})
                                      </h5>
                                    </div>
                                  )}
                                  {pickProduct.options.map(
                                    (pickOptionGroup, option_index) => (
                                      <span key={option_index}>
                                        {getOptionName(pickOptionGroup, lang)}
                                      </span>
                                    )
                                  )}
                                </div>
                              )
                            )}
                          </div>
                        </div>
                      )
                    )}
                  </div>
                  <div>
                    <h3 className="menuPrice">
                      {detail.product_total_amount.toLocaleString()}원
                    </h3>
                    <h4 className="quantity">{detail.product_quantity}개</h4>
                  </div>
                </div>
              </div>
            ))}
          </>
        ))}
      </div>
    );
  };

  return (
    <Style>
      <div className="paymentModalWrap">
        {orderDetailData && (
          <>
            <RenderHeader />
            <div className="orderName">
              <div className="row">
                {/* <h3>
                  {`주문번호 ${orderData.}`}
                </h3> */}
                <h4>
                  {moment(orderData.created_at).format("YYYY/MM/DD HH:mm:ss")}
                </h4>
              </div>
              <h3>{orderData.store_name}</h3>
            </div>
            <RenderPaymentList />
            {/* 요청사항 */}
            <div className="orderRequest">
              <h3>{langText.paymentListModal_title_request[lang]}</h3>
              <textarea
                placeholder={langText.paymentListModal_placeholder[lang]}
                value={
                  orderDetailData.order.child[0].inquiry
                    ? orderDetailData.order.child[0].inquiry
                    : ""
                }
                disabled={true}
              />
            </div>
            <div className="totalWrap">
              <div className="totalContent">
                <h3>{langText.paymentListModal_title_productPrice[lang]}</h3>
                <h3>
                  {" "}
                  {(
                    orderDetailData.order.child[0].total_amount_org! +
                    orderDetailData.order.child[0].prd_discount_amount!
                  ).toLocaleString()}
                  원
                </h3>
              </div>
              {/* <div className="totalContent">
              <h2>{langText.paymentListModal_title_orderAmount[lang]}</h2>
              <h3>{cartPay.total_amount_incl.toLocaleString()}원</h3>
            </div> */}
              <div className="totalContent">
                <h3>{langText.paymentListModal_title_delivery_cost[lang]}</h3>
                <h3>
                  {" "}
                  {orderDetailData.order.child[0].delivery_tip.toLocaleString()}
                  원
                </h3>
              </div>
              {/* TODO 번역 객실관리팁 */}
              {orderDetailData &&
                orderDetailData.order.child[0].room_tip > 0 && (
                  <div className="totalContent">
                    <h2>{langText.room_tip[lang]}</h2>
                    <h3>
                      {orderDetailData?.order?.child[0].room_tip.toLocaleString()}
                      원
                    </h3>
                  </div>
                )}
              {/* 할인금액 */}
              <div>
                {(orderDetailData.order.child[0].discount_amount! +
                  orderDetailData.order.child[0].prd_discount_amount! >
                  0 ||
                  couponList.length > 0) && (
                  <>
                    <div className="totalContent">
                      <div className="row gap">
                        <h3>
                          {langText.paymentListModal_title_discount[lang]}
                        </h3>
                        <div className="badge">
                          <h3>
                            {langText.paymentListModal_maximum_discount[lang]}
                          </h3>
                        </div>
                      </div>
                      <h3>
                        {orderDetailData.order.child[0].discount_amount! > 0
                          ? `-${(
                              orderDetailData.order.child[0].discount_amount! +
                              orderDetailData.order.child[0]
                                .prd_discount_amount!
                            ).toLocaleString()}원`
                          : `0원`}
                      </h3>
                    </div>

                    <div className="couponWrap">
                      {orderDetailData.order.child[0].prd_discount_amount! >
                        0 && (
                        <div className="totalContent discount">
                          <div className="row gap">
                            <img
                              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_lineBreak.svg`}
                              alt="옵션아이콘"
                            />
                            <h4>
                              {
                                langText
                                  .paymentListModal_title_product_discount[lang]
                              }
                            </h4>
                          </div>
                          <h4>
                            -{" "}
                            {orderDetailData.order.child[0].prd_discount_amount.toLocaleString()}
                            원
                          </h4>
                        </div>
                      )}
                      {couponList.length > 0 && (
                        <div className="totalContent discount coupon">
                          <div className="row gap">
                            <img
                              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_lineBreak.svg`}
                              alt="옵션아이콘"
                            />
                            <h4>
                              {
                                langText.paymentListModal_title_coupon_discount[
                                  lang
                                ]
                              }
                            </h4>
                          </div>
                          <div className="couponListWrap">
                            {couponList.map((item, index: number) => {
                              return (
                                <div key={index} className="discountInfo">
                                  <div className="couponName">
                                    <h4>•{item.coupon_name}</h4>
                                  </div>
                                  <div className="row">
                                    <h4>
                                      -
                                      {(
                                        item.com_discount_amount +
                                        item.store_discount_amount
                                      ).toLocaleString()}
                                      원
                                    </h4>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
            {/* 총결제금액 */}
            <div className="totalOrder">
              <h3>{langText.paymentListModal_title_totalPayment[lang]}</h3>
              <h3 className="quantity">
                {" "}
                {orderDetailData.order.child[0].detail.reduce(
                  (sum, obj) => sum + (obj.product_quantity || 0),
                  0
                )}
              </h3>
              <h3>
                {orderDetailData?.order?.child[0]?.total_amount_incl?.toLocaleString()}
                원
              </h3>
            </div>
            <div className="modalFooter">
              {/* <button onClick={() => {}}>
                <h2>{langText.orderStatus_button_delete[lang]}</h2>
              </button> */}
            </div>
          </>
        )}
      </div>
    </Style>
  );
};
export default OrderDetails;

const Style = styled.div`
  .paymentModalWrap {
    width: 100vw;
    height: 100%;
    min-height: 100dvh;
    display: flex;
    flex-direction: column;
  }

  .badge {
    padding: 2px 8px;
    border-radius: 50px;
    background: linear-gradient(90deg, #4ed2af 0%, #90c2e6 100%);
    h3 {
      white-space: nowrap;
      font-size: 12px;
      line-height: 14px;
      font-weight: 600;
      color: #fff;
    }
  }
  .row {
    display: flex;
    align-items: center;
  }
  .row.gap {
    gap: 6px;
  }

  /* modalHeader */
  .modalHeader {
    /* display: flex;
    align-items: center;
    justify-content: space-between; */
    padding: 20px 10px;
    text-align: center;
    position: relative;

    h3 {
      font-weight: 500;
    }
    .badge {
      padding: 4px 10px 2px 20px;
      display: flex;
      align-items: center;
      background: #ff6262;
      gap: 6px;
      border-radius: 5px;

      h3 {
        font-size: 20px;
        font-weight: 500;
        line-height: 30px;
      }
      h3.pickupName {
        white-space: normal;
        word-break: break-all;
        max-width: 60%;
      }
    }
    button {
      padding: 0;
    }

    .backIcon {
      position: absolute;
      left: 4px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .orderName {
    padding: 20px 12px;
    text-align: left;
    h4 {
      font-size: 14px;
      line-height: 20px;
      font-weight: 500;
      color: #a7a7a7;
    }
    h3 {
      padding-top: 10px;
      font-size: 18px;
      line-height: 24px;
      font-weight: 600;
    }
  }

  /* paymentListWrap */
  .paymentListWrap {
    width: 100%;
    min-height: 30dvh;
    max-height: 50dvh;
    flex: 1;
    padding: 0 10px;
    overflow-y: auto;
    background: #111111;
  }

  /* paymentContentWrap */
  .paymentContentWrap {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .menuContent {
    width: 100%;
    padding: 10px 0;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    border-bottom: 1px solid #282828;

    .orderIndex {
      margin-right: 10px;
      border: 1px solid #555555;
      border-radius: 4px;

      p {
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #e5e5e5;
        font-size: 12px;
        line-height: 12px;
        font-weight: 300;
      }
    }
  }

  /* orderList */

  .orderTitle {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;

    h3 {
      font-size: 16px;
      line-height: 24px;
    }
  }
  .orderMenu,
  .orderOption {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .orderOption {
    margin: 4px 0;
    justify-content: flex-start;

    p {
      font-size: 16px;
      font-weight: 300;
      color: #e5e5e5;
    }

    .optionCategory {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin: 0 5px;

      p {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .optionName {
      flex: 0 0 80%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .optionPrice {
      flex: 0 0 23%;
      text-align: right;
      margin-left: auto;
    }
  }
  .menuTitleWrap {
    .menuNameWrap {
      display: flex;
      align-items: center;
      h3 {
        white-space: normal;
      }
      .badge {
        margin-left: 6px;
        padding: 0;
        background: none;
        h3 {
          font-size: 14px;
          color: #ff6262;
          padding: 0;
        }
      }
    }
  }
  .menuNameShot,
  .menuName {
    display: flex;

    h3 {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .menuNameShot {
    max-width: 60%;
  }
  .menuName {
    max-width: 100%;
    font-weight: 500;
  }

  h4.quantity {
    text-align: right;
    margin-top: 16px;
    font-weight: 600;
  }

  .menuPrice {
    flex: 0 0 25%;
    text-align: right;
    font-weight: 500;
  }

  .optionLine {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 4px 0;

    img {
      padding-top: 2px;
    }

    .optionCategoryName,
    p {
      width: min-content;
      white-space: nowrap;
      margin: 0 4px;
      font-size: 12px;
      line-height: 16px;
      font-weight: 300;
      color: #e5e5e5;
    }
    .optionCategory {
      flex: 1;
    }
  }

  .optionBreak {
    display: flex;
    align-items: center;

    .optionBreakLine {
      border-right: 1px solid #fff;
      margin-right: 4px;
      height: 14px;
    }
    h5 {
      font-size: 12px;
      font-weight: 300;
      color: #e5e5e5;
      white-space: nowrap;
    }
  }
  .setOrderOption {
    display: flex;
    flex-wrap: wrap;
    .optionLineGroup {
      width: 100%;
    }
    span {
      font-size: 12px;
      line-height: 16px;
      font-weight: 300;
      color: #e5e5e5;
      margin-left: 4px;
      margin-bottom: 1px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  /* totalWrap */
  .totalWrap {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px 10px;
    border-bottom: 2px solid #1a1a1a;
  }
  .totalContent,
  .totalOrder {
    display: flex;
    align-items: center;
    justify-content: space-between;

    h2,
    h3 {
      font-weight: 500;
    }
    .badge {
      h3 {
        font-size: 11px;
        line-height: 13px;
      }
    }
  }
  .totalOrder {
    h3 {
      font-weight: 600;
    }
    h3.quantity {
      font-weight: 500;
    }
  }

  /* couponWrap */
  .couponWrap {
    max-height: 135px;
    overflow-y: auto;
  }

  .totalContent.coupon {
    .row.gap {
      gap: 4px;
    }
    input {
      width: 140px;
      padding: 2px 30px;
      border-radius: 5px;
      background: none;
      border: 1px solid #656565;
      font-size: 14px;
      line-height: 26px;
      color: #ffffff;
    }
    button {
      border: 1px solid #4dd2ae;
      border-radius: 5px;
      padding: 2px 12px;
      h4 {
        font-size: 14px;
        line-height: 26px;
        color: #4dd2ae;
      }
    }
  }

  .totalContent.discount {
    margin-top: 6px;
    /* margin-right: 27px; */
    margin-left: 60px;
    justify-content: space-between;
    align-items: flex-start;

    .row.gap {
      gap: 6px;
    }
    h4 {
      font-size: 13px;
      line-height: 20px;
      font-weight: 500;
      color: #ffffff;
    }
  }
  .totalContent.discount.coupon {
    justify-content: space-between;
    margin: 0;
    margin-left: 60px;

    .couponListWrap {
      width: calc(75% - 10px);
    }
    .discountInfo {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .couponName {
      max-width: 70%;
    }
    h4 {
      color: #4dd2ae;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .unavailableNotive {
      color: #ff4a4a;
      font-weight: 600;
    }
    .checkBox {
      margin-left: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 22px;
      height: 22px;
      padding: 0;
      border: 1px solid #4dd2ae;
      border-radius: 5px;
    }
  }

  .totalContent.discount.coupon.unavailable {
    display: flex;
    justify-content: space-between;
    flex-direction: column;

    .unavailable {
      width: 100%;
    }
    .unavailable .couponName {
      max-width: 70%;
      h4 {
        color: gray;
      }
    }
  }
  .totalOrder {
    margin: 0;
    padding: 18px 10px;
  }
  .orderRequest {
    padding: 20px 10px;
    border-bottom: 2px solid #1a1a1a;

    h2 {
      font-size: 24px;
      margin: 0;
    }
    h3 {
      margin-bottom: 8px;
      font-weight: 500;
    }
  }

  /* .commentBox {
    padding: 0 14px;
    margin-bottom: 6px;
    background: rgba(64, 151, 127, 0.5);
    border-radius: 50px;
    max-width: 100%;

    p {
      color: #ffffff;
      font-size: 14px;
      line-height: 24px;
      font-weight: 600;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .commentBox:after {
    content: " ";
    height: 0;
    width: 0;
    left: 110px;
    position: absolute;
    border: 5px solid transparent;
    border-bottom-width: 0;
    border-top-color: rgba(64, 151, 127, 0.5);
  } */

  /* orderRequest */
  .orderRequest {
    .requestCheckbox,
    label {
      display: flex;
      align-items: center;
    }
    .requestCheckbox {
      margin: 11px 0 16px 0;
      justify-content: space-between;
    }
    input {
      margin-right: 10px;
      accent-color: #40977f;
    }
    h2 {
      font-size: 22px;
      font-weight: 500;
    }
    span {
      font-size: 16px;
      font-weight: 400;
      color: #e5e5e5;
    }
    textarea {
      width: 100%;
      height: 42px;
      padding: 4px 10px;
      border-radius: 5px;
      background: none;
      border: 1px solid #656565;
      font-size: 14px;
      line-height: 32px;
      color: #ffffff;
    }
  }

  .modalFooter {
    /* padding: 10px; */
    padding-bottom: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    button {
      flex: 1;
      padding: 12px 0;
      border-radius: 5px;
      border: 1px solid #979797;
      background: #000000;
      h2 {
        font-size: 20px;
        line-height: 28px;
        font-weight: 600;
        color: #e5e5e5;
      }
    }
  }
`;
